import { useLayoutEffect, useRef, useState } from "react";
import { FormFlowStepShape } from "./styles";
import {
  getStepShapePath,
  STEP_SHAPE_FALLBACK_WIDTH,
  STEP_SHAPE_HEIGHT,
} from "./utils";

interface FormFlowStepShapeSvgProps {
  index: number;
  totalSteps: number;
}

export const FormFlowStepShapeSvg = ({
  index,
  totalSteps,
}: FormFlowStepShapeSvgProps) => {
  const shapeRef = useRef<SVGSVGElement | null>(null);
  const [width, setWidth] = useState(STEP_SHAPE_FALLBACK_WIDTH);

  useLayoutEffect(() => {
    const node = shapeRef.current;

    if (!node) {
      return;
    }

    const updateWidth = () => {
      const nextWidth = Math.round(node.getBoundingClientRect().width);

      if (nextWidth > 0) {
        setWidth((currentWidth) =>
          currentWidth === nextWidth ? currentWidth : nextWidth,
        );
      }
    };

    updateWidth();

    if (typeof ResizeObserver === "undefined") {
      return;
    }

    const resizeObserver = new ResizeObserver(updateWidth);
    resizeObserver.observe(node);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <FormFlowStepShape
      ref={shapeRef}
      data-step-shape="true"
      aria-hidden="true"
      focusable="false"
      viewBox={`0 0 ${width} ${STEP_SHAPE_HEIGHT}`}
      preserveAspectRatio="none"
    >
      <path d={getStepShapePath(index, totalSteps, width)} />
    </FormFlowStepShape>
  );
};
